const updateWidth = ($el: HTMLElement) => {
  
  const h = document.documentElement;
  const b = document.body;

  const percent = (h.scrollTop || b.scrollTop) / ((h.scrollHeight || b.scrollHeight) - h.clientHeight) * 100;
  
  $el.style.setProperty('width', Math.floor(percent) + '%');

}

export default () => {
  const $el = document.querySelectorAll<HTMLElement>(".js-reading-progress");

  $el.forEach(($element) => {
    document.addEventListener('scroll', () => {
      updateWidth($element);
    });
  });
};